import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Dataset, ABCisTableModel, ColumnType } from 'src/app/components/abcis-table/abcis-table.component';
import { ApiService, ABCisApi } from 'src/app/handlers/apiHandler.service';

@Component({
  selector: 'app-source-config',
  standalone: false,
  templateUrl: './source-config.component.html',
  styleUrls: ['./source-config.component.scss']
})
export class SourceConfigComponent implements OnInit {
  tableConfig: ABCisTableModel;
  showResumeConfirm = false;
  pendingActionRow: any = null;

  constructor(
    private apiHandler: ApiService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.SetTableConfig();
  }

  SetTableConfig() {
    this.tableConfig = {
      apiConfig: {
        api: ABCisApi.Support,
        table: 'null',
        url: 'source-configuration',
        approxamateRowCount: 1000,
        anyParams: true
      },
      colConfig: [
        { field: 'storeId', header: 'Store', type: ColumnType.MultiSelectComplex, setUrl: 'store/lookup', isReadonly: true, isPrimary: true  },
        { field: 'sourceTypeId', header: 'Source Type', type: ColumnType.DropDown, setUrl: 'source-type/lookup', isPrimary: true },
        { field: 'ocrEntryChannelJobId', header: 'OCR Entry Channel Job', type: ColumnType.DropDown, setUrl: 'ocr-entry-channel-job/lookup' },
        { field: 'importEnabled', header: 'Import Enabled', type: ColumnType.Boolean },
        {
          field: 'action',
          header: 'Actions',
          type: ColumnType.Action,
          actionLabel: 'Resume Import',
          actionIcon: 'pi pi-play',
          actionClass: 'p-button-sm p-button-danger',
          actionTooltip: 'Resume Import',
          width: '160px',
          minWidth: '160px',
          notInForm: true,
          isReadonly: true
        }
      ],
      addFormConfig: {
        header: 'Add Source Configuration'
      },
      isConfigurable: true
    };
  }

  onActionClick(event: { column: string; row: any; action: string }) {
    if (event.column !== 'action') return;

    this.pendingActionRow = event.row;
    this.showResumeConfirm = true;
  }

  confirmResumeImport() {
    const row = this.pendingActionRow;
    this.pendingActionRow = null;
    this.showResumeConfirm = false;

    const storeId = row?.storeId ?? row?.storeid;
    const sourceTypeId = row?.sourceTypeId ?? row?.sourcetypeid;
    if (storeId === undefined || storeId === null) {
      this.toastr.error('Invalid store id');
      return;
    }
    if (sourceTypeId === undefined || sourceTypeId === null) {
      this.toastr.error('Invalid source type id');
      return;
    }

    const url = `document/resume-import?storeId=${storeId}&sourceTypeId=${sourceTypeId}`;
    this.apiHandler.postABCisRequest(ABCisApi.Ocr, url)
      .then(() => {
        this.toastr.success('Resume import triggered');
      })
      .catch(error => {
        this.toastr.error(error?.error || 'Failed to resume import');
      });
  }

  cancelResumeImport() {
    this.pendingActionRow = null;
    this.showResumeConfirm = false;
  }
}
